/** 支持的语言，以及语言切换里显示的名字（用各自的语言写）。 */
export const LOCALES = [
  { code: 'en', label: 'English' },
  { code: 'zh', label: '中文' },
  { code: 'ja', label: '日本語' },
  { code: 'es', label: 'Español' },
  { code: 'id', label: 'Bahasa Indonesia' },
  { code: 'pt', label: 'Português' },
]
const supportedLocales = new Set(LOCALES.map((item) => item.code))
const LOCALE_KEY = 'voko.locale'

/**
 * @param {string} language
 */
export function localeFromLanguage(language) {
  const locale = language.toLowerCase().split('-')[0]
  return supportedLocales.has(locale) ? locale : 'en'
}

/** 手动选过的语言优先，否则按浏览器语言。 */
export function initialLocale() {
  return localeFromLanguage(localStorage.getItem(LOCALE_KEY) ?? navigator.language)
}

/** @param {string} locale */
export function saveLocale(locale) {
  localStorage.setItem(LOCALE_KEY, locale)
}
